import { render, staticRenderFns } from "./CultureDiversity.vue?vue&type=template&id=47b17acf&"
import script from "./CultureDiversity.vue?vue&type=script&lang=js&"
export * from "./CultureDiversity.vue?vue&type=script&lang=js&"
import style0 from "./CultureDiversity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports